module.exports = __webpack_public_path__ + "img/face-tissue.0e61562f.svg";